import React, { useState } from "react";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const handleNavClick = () => {
    setOpen(false);
  };

  return (
    <header className="navbar">
      <div className="container navbar-inner">
        <div className="logo">
          <a href="#top" className="logo-mark">
            <span className="logo-symbol">
              <img src="/images/logo.jpg" alt="Calowry Logo" />
            </span>
            <span className="logo-text">
              Calowry <span className="logo-sub">Chocolate</span>
            </span>
          </a>
        </div>

        <nav className={open ? "nav nav-open" : "nav"}>
          <ul className="nav-links">
            <li>
              <a href="#technology" onClick={handleNavClick}>
                Technology
              </a>
            </li>
            <li>
              <a href="#benefits" onClick={handleNavClick}>
                Benefits
              </a>
            </li>
            <li>
              <a href="#chefs" onClick={handleNavClick}>
                For chocolatiers
              </a>
            </li>
            <li>
              <a href="#contact" onClick={handleNavClick}>
                Contact
              </a>
            </li>
          </ul>
          <div className="nav-actions">
            <a href="#contact" className="nav-cta" onClick={handleNavClick}>
              Talk to our team
            </a>
          </div>
        </nav>

        <button
          className="nav-toggle"
          type="button"
          onClick={() => setOpen(!open)}
        >
          <span className="nav-toggle-line" />
          <span className="nav-toggle-line" />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
